import type { OrgFunctionKind } from '@bliks-io/contracts';

/**
 * Translation-key set for the lead field, which is named after the kind it
 * belongs to: a team's lead is the "Teamleitung", a role's lead the
 * "Funktionsleitung". Centralised so every surface (form dialog, detail page)
 * derives the same wording from `kind` instead of re-deriving the ternary.
 */
export function leadLabelKeys(kind: OrgFunctionKind) {
  const prefix = 'organization.orgFunctions';
  return kind === 'team'
    ? {
        label: `${prefix}.teamLead`,
        placeholder: `${prefix}.selectTeamLead`,
        clear: `${prefix}.noTeamLead`
      }
    : {
        label: `${prefix}.lead`,
        placeholder: `${prefix}.selectLead`,
        clear: `${prefix}.noLead`
      };
}
